// extracted by mini-css-extract-plugin
export default {"jobsContainer":"Jobs_jobsContainer__lGo8T","title":"Jobs_title__XhVTF","jobCard":"Jobs_jobCard__pDHCG","jobTitle":"Jobs_jobTitle__Pzgov","emailLink":"Jobs_emailLink__gJRc0"};